import { css } from 'styled-components';


export const imHereSmall = css`
  animation: imhereSmall 1.5s infinite;
  @keyframes imhereSmall {
    0% { transform: scale(1); }
    50% { transform: scale(0.95); }
    100% { transform: scale(1); }
  }
`

export const imHere = css`
animation: imhere 2s infinite;
  @keyframes imhere {
    0% { transform: scale(1); }
    50% { transform: scale(0.9); }
    100% { transform: scale(1); }
  }
`;

export const fadeIn = css`
  animation: fadeIn 0.7s ease-out;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const fadeOut = css`
  animation: fadeOut 0.7s ease-out;
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const blink = css`
  animation: blink 1.5s infinite;
  @keyframes blink {
    0% { transform: scale(1); }
    50% { transform: scale(0.8); }
    100% { transform: scale(1); }
  }
`;

// export const shake = css`
//   animation: shake 0.4s ease-in-out;
//   @keyframes shake {
//     0%, 100% { transform: translateX(0);}
//     20% { transform: translateX(-4px);}
//     40% { transform: translateX(4px);}
//     60% { transform: translateX(-3px);}
//     80% { transform: translateX(3px);}
//   }
// `;

export const slideInFromLeft = css`
  animation: slideInFromLeft 0.5s ease-out;
  @keyframes slideInFromLeft {
    from {
      transform: translateX(-100%);
      opacity: 0.5;
    }
          to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const slideInFromLeftWeighted = css`
  animation: slideInFromLeft 0.7s ease-out;
  @keyframes slideInFromLeft {
    from {
      transform: translateX(-100%);
      opacity: 0.5;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const slideInFromRight = css`
  animation: slideInFromRight 0.5s ease-out;
  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const slideInFromRightWeighted = css`
  animation: slideInFromRight 0.7s ease-out;
  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
      opacity: 0.5;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

export const slideInFromBottom = css`
  animation: slideInFromBottom 0.5s ease-out;
  @keyframes slideInFromBottom {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const slideInFromTop = css`
  animation: slideInFromTop 0.5s ease-out;
  @keyframes slideInFromTop {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const popIn = css`
  animation: popIn 0.4s ease-out;
  @keyframes popIn {
    0% {
      opacity: 0;
      transform: scale(0.95);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;